import { render, staticRenderFns } from "./LocationServiceContactRow.vue?vue&type=template&id=2f076626&scoped=true"
import script from "./LocationServiceContactRow.vue?vue&type=script&lang=js"
export * from "./LocationServiceContactRow.vue?vue&type=script&lang=js"
import style0 from "./LocationServiceContactRow.vue?vue&type=style&index=0&id=2f076626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f076626",
  null
  
)

export default component.exports